import React from "react";
import { Link } from "react-router-dom";
import settings from "@content/settings.json";
import company from "@content/legal/company.json";

const socialIcons = {
    email: {
        label: "Email",
        d: "M4 6h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Zm.4 2 7.6 5.3L19.6 8H4.4Z",
    },
    instagram: {
        label: "Instagram",
        d: "M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 2 .3 2.6.5.7.3 1.3.6 1.9 1.2s1 1.2 1.2 1.9c.2.6.4 1.4.5 2.6.1 1.2.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.3 2-.5 2.6-.3.7-.6 1.3-1.2 1.9s-1.2 1-1.9 1.2c-.6.2-1.4.4-2.6.5-1.2.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-2-.3-2.6-.5a5 5 0 0 1-1.9-1.2 5 5 0 0 1-1.2-1.9c-.2-.6-.4-1.4-.5-2.6C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8c.1-1.2.3-2 .5-2.6.3-.7.6-1.3 1.2-1.9s1.2-1 1.9-1.2c.6-.2 1.4-.4 2.6-.5C8.4 2.2 8.8 2.2 12 2.2Zm0 1.8c-3.2 0-3.5 0-4.7.1-1.1.1-1.7.2-2.1.4-.5.2-.9.4-1.3.8-.4.4-.6.8-.8 1.3-.2.4-.3 1-.4 2.1-.1 1.2-.1 1.5-.1 4.7s0 3.5.1 4.7c.1 1.1.2 1.7.4 2.1.2.5.4.9.8 1.3.4.4.8.6 1.3.8.4.2 1 .3 2.1.4 1.2.1 1.5.1 4.7.1s3.5 0 4.7-.1c1.1-.1 1.7-.2 2.1-.4.5-.2.9-.4 1.3-.8.4-.4.6-.8.8-1.3.2-.4.3-1 .4-2.1.1-1.2.1-1.5.1-4.7s0-3.5-.1-4.7c-.1-1.1-.2-1.7-.4-2.1-.2-.5-.4-.9-.8-1.3a3.3 3.3 0 0 0-1.3-.8c-.4-.2-1-.3-2.1-.4-1.2-.1-1.5-.1-4.7-.1Zm0 3.1a4.9 4.9 0 1 1 0 9.8 4.9 4.9 0 0 1 0-9.8Zm0 8.1a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Zm5.1-8.3a1.2 1.2 0 1 1 0-2.3 1.2 1.2 0 0 1 0 2.3Z",
    },
    linkedin: {
        label: "LinkedIn",
        d: "M4.98 3.5a2.5 2.5 0 1 1 0 5.001 2.5 2.5 0 0 1 0-5.001ZM3 9h4v12H3V9Zm7 0h3.8v1.71h.05a4.16 4.16 0 0 1 3.75-2.06c4.01 0 4.75 2.64 4.75 6.07V21h-4v-5.31c0-1.27-.02-2.9-1.77-2.9-1.77 0-2.04 1.38-2.04 2.81V21h-4V9Z",
    },
    youtube: {
        label: "YouTube",
        d: "M23 7.2a3 3 0 0 0-2.1-2.1C19 4.5 12 4.5 12 4.5s-7 0-8.9.6A3 3 0 0 0 1 7.2 31.5 31.5 0 0 0 .5 12 31.5 31.5 0 0 0 1 16.8a3 3 0 0 0 2.1 2.1c1.9.6 8.9.6 8.9.6s7 0 8.9-.6a3 3 0 0 0 2.1-2.1 31.5 31.5 0 0 0 .5-4.8 31.5 31.5 0 0 0-.5-4.8ZM9.8 15.6V8.4l6.3 3.6-6.3 3.6Z",
    },
    facebook: {
        label: "Facebook",
        d: "M13.4 22v-8h2.7l.4-3.1h-3.1V8.9c0-.9.3-1.5 1.6-1.5h1.6V4.6c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4v2.4H7.5V14h2.6v8h3.3Z",
    },
};

const LEGAL_LINKS = [
    { to: "/privacy-policy", label: "Privacy Policy" },
    { to: "/terms-and-conditions", label: "Terms & Conditions" },
    { to: "/refund-policy", label: "Refund Policy" },
    { to: "/about-us", label: "About Us" },
    { to: "/contact-us", label: "Contact Us" },
    { to: "/#faq", label: "FAQ" },
];

const Footer = () => {
    const email = company.supportEmail || settings.email;
    const phoneDigits = (company.supportPhone || "").replace(/\D/g, "");
    const brand = company.brandName || settings.brand_name || "Grads2Pro";
    const legalName = company.companyName || "Grads2Pro EdTech LLP";

    const contactLinks = [
        email && { key: "email", href: `mailto:${email}`, ...socialIcons.email, value: email },
        company.instagram && { key: "instagram", href: company.instagram, ...socialIcons.instagram, value: socialIcons.instagram.label },
        company.linkedin && { key: "linkedin", href: company.linkedin, ...socialIcons.linkedin, value: socialIcons.linkedin.label },
        company.youtube && { key: "youtube", href: company.youtube, ...socialIcons.youtube, value: socialIcons.youtube.label },
        company.facebook && { key: "facebook", href: company.facebook, ...socialIcons.facebook, value: socialIcons.facebook.label },
    ].filter(Boolean);

    const year = new Date().getFullYear();

    return (
        <footer className="relative border-t border-[var(--border)] mt-10">
            <div className="section pb-10">
                <div className="container-p">
                    {/* Final CTA */}
                    <div className="panel p-6 md:p-10 relative overflow-hidden">
                        <div
                            className="absolute inset-0 bg-dots opacity-40 pointer-events-none"
                            aria-hidden
                        />
                        <div
                            className="absolute -top-24 -right-16 w-[420px] h-[420px] rounded-full pointer-events-none"
                            style={{
                                background:
                                    "radial-gradient(circle, rgba(124,231,59,0.18), transparent 60%)",
                            }}
                            aria-hidden
                        />
                        <div className="relative grid md:grid-cols-1 items-center gap-4 text-center">
                            <div>
                                <div className="font-mono text-xs uppercase tracking-widest text-brand">
                                    Still in Desktop Support?
                                </div>
                                <h2
                                    className="mt-3 font-display text-3xl md:text-5xl font-extrabold text-slate-900 leading-tight"
                                    data-testid="footer-cta-heading"
                                >
                                    Your next career move{" "}
                                    <span className="text-brand">starts this Monday.</span>
                                </h2>
                            </div>
                            <p className="text-sm text-mute" data-testid="footer-cta-social-proof">
                                Join 600+ engineers who already made the switch.
                            </p>
                            <div className="flex justify-center">
                                <a
                                    href={settings.razorpay_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-primary text-lg py-4 px-6"
                                    data-testid="footer-cta"
                                >
                                    Reserve My Seat – ₹799 →
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Footer grid */}
                    <div className="mt-10 grid md:grid-cols-[1.6fr_1fr_1fr_1fr] gap-8">
                        <div>
                            <div className="font-mono text-2xl font-bold text-slate-900 tracking-tight">
                                {brand.replace(/(\d)/, "|$1|")
                                    .split("|")
                                    .map((chunk, i) =>
                                        /^\d$/.test(chunk) ? (
                                            <span key={i} className="text-brand">
                                                {chunk}
                                            </span>
                                        ) : (
                                            <span key={i}>{chunk}</span>
                                        )
                                    )}
                                <span className="text-brand">_</span>
                            </div>
                            <p className="mt-3 text-sm text-dim leading-relaxed max-w-md">
                                {settings.company_tagline}
                            </p>
                            {email && (
                                <a
                                    href={`mailto:${email}`}
                                    className="mt-4 inline-flex items-center gap-2 text-sm text-dim hover:text-slate-900"
                                    data-testid="footer-support-email"
                                >
                                    <span aria-hidden>✉</span> {email}
                                </a>
                            )}
                            {phoneDigits && (
                                <a
                                    href={`tel:+${phoneDigits}`}
                                    className="mt-1 flex items-center gap-2 text-sm text-dim hover:text-slate-900"
                                    data-testid="footer-support-phone"
                                >
                                    <span aria-hidden>☎</span> {company.supportPhone}
                                </a>
                            )}
                        </div>

                        <div>
                            <div className="font-mono text-xs uppercase tracking-widest text-brand">
                                Company
                            </div>
                            <ul className="mt-4 space-y-2">
                                {LEGAL_LINKS.map((l) =>
                                    l.to.startsWith("/#") ? (
                                        <li key={l.to}>
                                            <a
                                                href={l.to.slice(1)}
                                                className="text-sm text-dim hover:text-slate-900"
                                                data-testid={`footer-nav-${l.label
                                                    .toLowerCase()
                                                    .replace(/[^a-z0-9]+/g, "-")}`}
                                            >
                                                {l.label}
                                            </a>
                                        </li>
                                    ) : (
                                        <li key={l.to}>
                                            <Link
                                                to={l.to}
                                                className="text-sm text-dim hover:text-slate-900"
                                                data-testid={`footer-nav-${l.label
                                                    .toLowerCase()
                                                    .replace(/[^a-z0-9]+/g, "-")}`}
                                            >
                                                {l.label}
                                            </Link>
                                        </li>
                                    )
                                )}
                            </ul>
                        </div>

                        <div>
                            <div className="font-mono text-xs uppercase tracking-widest text-brand">
                                Connect
                            </div>
                            <ul className="mt-4 space-y-2.5">
                                {contactLinks.map((s) => (
                                    <li key={s.key}>
                                        <a
                                            href={s.href}
                                            target={s.key === "email" ? "_self" : "_blank"}
                                            rel="noopener noreferrer"
                                            className="inline-flex items-center gap-2.5 text-sm text-dim hover:text-slate-900 transition-colors"
                                            data-testid={`footer-${s.key}`}
                                        >
                                            <span className="w-8 h-8 rounded-lg border border-[var(--border)] bg-white flex items-center justify-center text-slate-500">
                                                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                                                    <path d={s.d} />
                                                </svg>
                                            </span>
                                            <span>
                                                {s.key === "email" ? email : s.label}
                                            </span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div>
                            <div className="font-mono text-xs uppercase tracking-widest text-brand">
                                Office
                            </div>
                            <p className="mt-4 text-sm text-mute leading-relaxed">
                                {company.fullAddress || settings.address}
                            </p>
                            {(company.gstin || company.llpin) && (
                                <p className="mt-3 font-mono text-[11px] text-mute leading-relaxed break-all">
                                    {company.llpin && <>LLPIN · {company.llpin}<br /></>}
                                    {company.gstin && <>GSTIN · {company.gstin}</>}
                                </p>
                            )}
                        </div>
                    </div>

                    <hr className="hr-dashed mt-6" />
                    <div className="mt-4 flex flex-wrap items-center justify-between gap-3 text-xs text-mute font-mono">
                        <div data-testid="footer-copyright">
                            © {year} {legalName}. All Rights Reserved.
                        </div>
                        <div>Made with ☕ &amp; packets in Mumbai</div>
                    </div>
                </div>
            </div>

            {/* Sticky mobile CTA */}
            <div className="sticky-cta">
                <div className="flex items-center justify-between w-full gap-3">
                    <div className="min-w-0">
                        <div className="font-mono text-[10px] uppercase tracking-widest text-brand">
                            Reserve seat
                        </div>
                        <div className="text-slate-900 font-bold text-sm truncate">
                            ₹799 · Monday batch closing soon
                        </div>
                    </div>
                    <a
                        href={settings.razorpay_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-primary py-2.5 px-4 text-sm"
                        data-testid="sticky-cta"
                    >
                        Reserve →
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
